import '../styles/locationMap.modules.css';

function LocationMap({ location }) {
  const hasCoords =
    Number.isFinite(location?.lat) && Number.isFinite(location?.lng);

  const query = hasCoords
    ? `${location.lat},${location.lng}`
    : `${location?.name ?? ""} ${location?.address ?? ""}`.trim();

  if (!query) return null;

  const embedSrc = `https://www.google.com/maps?q=${encodeURIComponent(query)}&z=16&output=embed`;

  const openHref = hasCoords
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

  const navigateHref = hasCoords
    ? `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`
    : `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(query)}`;

  return (
    <section className="map_section">
      <div className="map_header">
        <p className="map_subtitle">
          {location?.name}
          {location?.address ? ` • ${location.address}` : ""}
        </p>
      </div>

      <div className="map_card">
        <iframe
          className="map_iframe"
          src={embedSrc}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          title={`Mapa - ${location?.name ?? "lokalizacja"}`}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "10px",
          justifyContent: "center",
        }}
      >
        <a
          className="map_btn"
          href={navigateHref}
          target="_blank"
          rel="noopener noreferrer"
          style={{ backgroundColor: location?.color }}
        >
          Prowadź
        </a>

        <a
          className="map_btn"
          href={openHref}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: "rgba(255,255,255,0.95)",
            color: "rgba(0,0,0,0.85)",
            border: "1px solid rgba(0,0,0,0.12)",
          }}
        >
          Otwórz w mapach
        </a>
      </div>
    </section>
  );
}

export default LocationMap;